import { ENV } from "../utils";

export class EscalationRules {
  baseApi = ENV.BASE_API;

  async getEscalationRules(accessToken) {
    const response = await fetch(`${this.baseApi}/escalation-rules`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateEscalationRules(accessToken, data) {
    const response = await fetch(`${this.baseApi}/escalation-rules`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
